import React, { memo } from 'react';
import WorkspaceCard from './WorkspaceCard';

/**
 * WorkspaceGrid
 * Responsive grid of WorkspaceCards. Purely presentational — drag state and
 * handlers are owned by the launcher and threaded through.
 */
const WorkspaceGrid = ({
  apps,
  gridSize = 'large',
  activeAppId,
  draggable = false,
  dragId = null,
  dropTargetId = null,
  onOpen,
  onToggleFavorite,
  onContextMenu,
  onDragStart,
  onDragEnter,
  onDragEnd,
  onDrop,
}) => {
  if (!apps || apps.length === 0) return null;

  return (
    <div className={`ws-grid size-${gridSize}`}>
      {apps.map((app) => (
        <WorkspaceCard
          key={app.id}
          app={app}
          active={activeAppId === app.id}
          draggable={draggable}
          isDragging={dragId === app.id}
          isDropTarget={dropTargetId === app.id && dragId !== app.id}
          onOpen={onOpen}
          onToggleFavorite={onToggleFavorite}
          onContextMenu={onContextMenu}
          onDragStart={onDragStart}
          onDragEnter={onDragEnter}
          onDragEnd={onDragEnd}
          onDrop={onDrop}
        />
      ))}
    </div>
  );
};

export default memo(WorkspaceGrid);
